export const BLOCK_TYPES = {
  TITLE: 'TITLE',
  QUESTION: 'QUESTION',
  QUESTIONS_TABLE: 'QUESTIONS_TABLE',
  DIVIDER: 'DIVIDER'
};

export const INPUT_TYPE = {
  TEXT: 'text',
  MULTILINE: 'multiline',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  // DROPDOWN: "dropdown",
  SCALE: 'scale',
};

export const INPUT_OPTIONS = [
  { label: 'Short answer', value: INPUT_TYPE.TEXT },
  { label: 'Long answer', value: INPUT_TYPE.MULTILINE },
  { label: 'Multiple Choice', value: INPUT_TYPE.RADIO },
  { label: 'Checkboxes', value: INPUT_TYPE.CHECKBOX },
];
